import React from 'react';
import { motion } from 'framer-motion';

import Feature1Image from '../assets/feature1.jpg';
import Feature2Image from '../assets/feature2.jpg';
import Feature3Image from '../assets/feature3.jpg';

const features = [
  {
    title: 'Disagree? Challenge Accepted.',
    description:
      'Settle the score once and for all with BantrBox. When you and your friends can’t agree on who’s right, BantrBox gives you the perfect platform to settle the argument. Create a challenge, define the stakes, and let your friends join the fun by adding their own banter and insights. With a trackable system and a space for playful jabs, BantrBox makes every disagreement entertaining, engaging, and downright unforgettable.',
    image: Feature1Image,
  },
  {
    title: 'Your Next Adventure Starts Here',
    description:
      'Challenge your friends to prove their bold claims, hold them accountable to their promises, or take on exciting adventures together. Whether it’s proving who’s the real trivia master, making sure that bungee jump happens, or finally running that marathon, BantrBox turns casual conversations into meaningful actions. Say it, do it, and create memories that you’ll talk about for years.',
    image: Feature2Image,
  },
  {
    title: 'Where Challenges Create Change',
    description:
      'Be part of something bigger with BantrBox community challenges. You’re not just participating; you’re shaping the future. Join community-driven movements that spark conversations, fuel trends, and back the causes that matter most. Cheer for your local sports heroes, take part in challenges that spread positivity, or organize efforts to make real-world change. This is your chance to turn ordinary moments into extraordinary impact.',
    image: Feature3Image,
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const FeatureSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 space-y-16">
        {features.map((feature, index) => {
          const isEven = index % 2 === 1;
          return (
            <motion.div
              key={index}
              className={`flex flex-col md:flex-row items-center gap-8 ${isEven ? 'md:flex-row-reverse' : ''}`}
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.div className="md:w-1/2" variants={itemVariants}>
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-auto rounded-lg shadow-lg"
                />
              </motion.div>
              <motion.div className="md:w-1/2 text-[#333333]" variants={itemVariants}>
                <h3 className="text-3xl font-bold mb-4">{feature.title}</h3>
                <p className="text-[#666666] text-lg leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default FeatureSection;
